import { render, staticRenderFns } from "./EmbeddedDocList.vue?vue&type=template&id=db1651f4&scoped=true"
import script from "./EmbeddedDocList.vue?vue&type=script&lang=js"
export * from "./EmbeddedDocList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1651f4",
  null
  
)

export default component.exports